import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/default_placeholder.svg'
import _imports_1 from '@/assets/calendar.svg'


const _hoisted_1 = { class: "product-card__image-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "ds-aspect-ratio ds-aspect-ratio--ratio_16x9 ds-aspect-ratio--appearance_covered ds-aspect-ratio--appearance_cuted"
}
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "ds-aspect-ratio ds-aspect-ratio--ratio_16x9 ds-aspect-ratio--appearance_covered ds-aspect-ratio--appearance_cuted img-placeholder"
}
const _hoisted_6 = { class: "promo-labels" }
const _hoisted_7 = { class: "product-card-actions" }
const _hoisted_8 = ["onClick", "aria-label"]
const _hoisted_9 = ["onClick", "aria-label"]
const _hoisted_10 = ["onClick", "aria-label"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "product-card__content" }
const _hoisted_13 = { class: "product-card__title-wrap" }
const _hoisted_14 = ["innerHTML", "href"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "product-card__info" }
const _hoisted_17 = { class: "product-card__category" }
const _hoisted_18 = { class: "product-card__location" }
const _hoisted_19 = { class: "ds-inliner ds-inliner--size_2xl" }
const _hoisted_20 = { class: "ds-inliner__body" }
const _hoisted_21 = { class: "ds-caption ds-caption--size_xs ds-caption--color_1" }
const _hoisted_22 = { class: "product-card__details" }
const _hoisted_23 = { class: "offer-characteristic" }
const _hoisted_24 = { class: "offer-property offer-characteristic__item" }
const _hoisted_25 = { class: "offer-property__image-wrap" }
const _hoisted_26 = ["alt"]
const _hoisted_27 = { class: "offer-property__title" }
const _hoisted_28 = { class: "offer-property__value" }
const _hoisted_29 = {
  key: 0,
  class: "offer-property offer-characteristic__item"
}
const _hoisted_30 = { class: "offer-property__image-wrap" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "offer-property__title" }
const _hoisted_33 = { class: "offer-property__value" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "product-card__footer" }
const _hoisted_36 = { class: "product-card__price-wrap" }
const _hoisted_37 = { class: "product-card__price" }
const _hoisted_38 = { class: "product-card__price-per-period" }
const _hoisted_39 = { class: "product-card__duration" }
const _hoisted_40 = { class: "product-card__buttons-wrap" }
const _hoisted_41 = ["href", "aria-label"]
const _hoisted_42 = {
  class: "control-button__body",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "control-button__element control-button__element--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_FavoriteToggler = _resolveComponent("FavoriteToggler")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_ComparisonsToggler = _resolveComponent("ComparisonsToggler")!
  const _component_UiModalTrigger = _resolveComponent("UiModalTrigger")!

  return (_openBlock(), _createElementBlock("div", {
    class: "product-card",
    onFocusin: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.item?.photos?.[0]?.image)
        ? (_openBlock(), _createElementBlock("picture", _hoisted_2, [
            _createElementVNode("source", {
              type: "image/webp",
              srcset: $props.item.photos[0].image?.webp
            }, null, 8, _hoisted_3),
            _createElementVNode("img", {
              class: "ds-aspect-ratio__body d-block",
              src: $props.item.photos[0].image.origin
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("picture", _hoisted_5, _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              class: "ds-aspect-ratio__body d-block img-placeholder__img",
              src: _imports_0,
              loading: "lazy"
            }, null, -1)
          ]))),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.labels, (label) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "promo-labels__item",
            key: label.title,
            style: _normalizeStyle({ '--bg-color': label.backgroundColor || 'inherit', '--fg-color': label.foregroundColor || 'inherit' })
          }, _toDisplayString(label.title), 5))
        }), 128))
      ]),
      _renderSlot(_ctx.$slots, "product-card-actions", { item: $props.item }, () => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FavoriteToggler, {
            state: $props.item.isFavorite,
            id: $props.item.id,
            onFinishFavorite: $setup.onChangeFavorite
          }, {
            default: _withCtx(({ toggle, state }) => [
              _createElementVNode("button", {
                class: _normalizeClass(["product-card-actions__el-button product-card-actions__el-button--variant_favorites", { 'is-active': state }]),
                type: "button",
                onClick: ($event: any) => (toggle()),
                "aria-label": state ? _ctx.$t('Remove from favorite') : _ctx.$t('Add to favorite')
              }, [
                _createVNode(_component_AppIcon, {
                  name: "i-star",
                  size: "xl"
                })
              ], 10, _hoisted_8)
            ]),
            _: 1
          }, 8, ["state", "id"]),
          ($props.item.statusModeration.value == $setup.OfferStatusModeration.PASSED)
            ? (_openBlock(), _createBlock(_component_ComparisonsToggler, {
                key: 0,
                state: $props.item.isCompared,
                id: $props.item.id,
                onFinishComparison: $setup.onChangeComparison
              }, {
                default: _withCtx(({ toggle, state }) => [
                  _createElementVNode("button", {
                    class: _normalizeClass(["product-card-actions__el-button product-card-actions__el-button--variant_comparison", { 'is-active': state }]),
                    type: "button",
                    onClick: ($event: any) => (toggle()),
                    "aria-label": state ?  _ctx.$t('Remove from comparison') : _ctx.$t('Add to comparison')
                  }, [
                    _createVNode(_component_app_icon, {
                      name: "i-scales",
                      size: "xl",
                      "aria-hidden": "true"
                    })
                  ], 10, _hoisted_9)
                ]),
                _: 1
              }, 8, ["state", "id"]))
            : _createCommentVNode("", true),
          ($props.item.statusModeration.value == $setup.OfferStatusModeration.PASSED)
            ? (_openBlock(), _createBlock(_component_UiModalTrigger, {
                key: 1,
                component: "ShareElement",
                name: "ShareElement",
                link: $setup.origin + $props.item.offerLink,
                title: $props.item.titleGenerate
              }, {
                default: _withCtx(({ open }) => [
                  _createElementVNode("button", {
                    class: "product-card-actions__el-button",
                    type: "button",
                    onClick: ($event: any) => (open()),
                    "aria-label": _ctx.$t('Share an offer')
                  }, [
                    _createVNode(_component_app_icon, {
                      "aria-hidden": "true",
                      name: "i-share",
                      size: "xl"
                    })
                  ], 8, _hoisted_10)
                ]),
                _: 1
              }, 8, ["link", "title"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _renderSlot(_ctx.$slots, "status", { item: $props.item }),
      ($props.item.statusModeration.value === $setup.OfferStatusModeration.PASSED)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "product-card__image-link",
            href: $props.item.offerLink
          }, _toDisplayString($props.item.titleGenerate), 9, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("h3", _hoisted_13, [
        ($props.item.statusModeration.value === $setup.OfferStatusModeration.PASSED)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "product-card__title product-card__title--link",
              innerHTML: $props.item.titleGenerate,
              href: $props.item.offerLink
            }, null, 8, _hoisted_14))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "product-card__title",
              innerHTML: $props.item.titleGenerate
            }, null, 8, _hoisted_15))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", _hoisted_17, [
          _createElementVNode("span", null, _toDisplayString($props.item.categoryPrimary.title), 1),
          _createElementVNode("span", null, _toDisplayString($props.item.id), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              _createElementVNode("span", {
                class: _normalizeClass(["fi fis flag-wrap", `fi-${($props.item.locationCountry.code2).toLowerCase()}`])
              }, null, 2)
            ])
          ]),
          _createElementVNode("span", _hoisted_21, _toDisplayString($props.item.locationCountry.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("img", {
                class: "offer-property__image",
                src: _imports_1,
                alt: _ctx.$t('Offer first registration icon calendar')
              }, null, 8, _hoisted_26)
            ]),
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("First regist.")), 1),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$d(new Date($props.item.firstRegistration), 'year', _ctx.$_locale)), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.attributesConfiguration.attributes, (attributeConfig, id, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: id }, [
              (attributeConfig.displayInPreview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("img", {
                        class: "offer-property__image",
                        src: attributeConfig.icon,
                        alt: attributeConfig.iconAlt || ''
                      }, null, 8, _hoisted_31)
                    ]),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(attributeConfig.attribute.title), 1),
                    _createElementVNode("p", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.attributeValues, (attrValue) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: attrValue.id
                        }, [
                          (String(attrValue.attribute) === String(id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                _createTextVNode(_toDisplayString(attrValue.valueVerbose) + " ", 1),
                                (attributeConfig.attribute.unit)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(attributeConfig.attribute.unit.title), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("p", _hoisted_37, [
            _createTextVNode(_toDisplayString(_ctx.$n(Number($props.item.priceMonthly), 'currency')), 1),
            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("/ month")), 1)
          ]),
          _createElementVNode("div", _hoisted_39, _toDisplayString($setup.pluralFinancingPeriod + " " + _ctx.$t("duration")), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          ($props.item.statusModeration.value === $setup.OfferStatusModeration.PASSED)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "control-button control-button--styling_accent control-button--size_md control-button--view_full",
                href: $props.item.offerLink,
                "aria-label": $props.item.titleGenerate
              }, [
                _createElementVNode("span", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("More")), 1)
                ])
              ], 8, _hoisted_41))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 32))
}